import React from 'react'
import PropTypes from 'prop-types'
import MPGridRow from './MPGridRow'

function MPGridHeader (props) {
  /*
    * This is an edge-case of MPGridRow that defaults to 100% and justifies content with 'space-between'
    * It's separate from the grid as it does not adhere to the grid.
    * For now only intended for the Header.)
  */

  const headerStyle = {
    flexWrap: 'nowrap'
  }

  const alignItemsStyle = props.alignItems ? { alignItems: `${props.alignItems}` } : ''
  const justifyContentStyle = props.justifyContent ? { justifyContent: `${props.justifyContent}` } : ''
  const inheritedStyles = props.style ? props.style : ''

  return (
    <MPGridRow style={{ ...headerStyle, ...alignItemsStyle, ...justifyContentStyle, ...inheritedStyles }}>
      {props.children}
    </MPGridRow>
  )
}

MPGridHeader.propTypes = {
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  justifyContent: PropTypes.oneOf(['space-between']),
  style: PropTypes.object,
  children: PropTypes.node
}

MPGridHeader.defaultProps = {
  justifyContent: 'space-between',
  alignItems: 'center'
}

export default MPGridHeader
